export default __webpack_public_path__ + "static/media/palta-logo-500.00bbfbd7.svg";